import { render, staticRenderFns } from "./merchant-application-success.vue?vue&type=template&id=d5300988&lang=pug"
import script from "./merchant-application-success.vue?vue&type=script&lang=js"
export * from "./merchant-application-success.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports